import React from 'react';
import styled from '@emotion/styled';
// ---- external imports ----

import Asset from '../BaseAssets';
// ---- parent imports ----

function NewspaperPreview(props) {
	const testBase = `${props?.testBaseName}-preview`;

	return (
		<>
			<NewspaperText
				x={720}
				y={176}
				projection={{
					width: 480,
					height: 28
				}}
				fontSize={21.5}
				data-testid={`${testBase}-title`}
			>
				{props.entry.previewTitleText}
			</NewspaperText>
			<NewspaperText
				x={props.displayDetails.topDescription.x}
				y={props.displayDetails.topDescription.y}
				projection={{
					width: props.displayDetails.topDescription.w,
					height: props.displayDetails.topDescription.h
				}}
				fontSize={props.displayDetails.topDescription.fontSize}
				data-testid={`${testBase}-top-description`}
			>
				{props.entry.topDescription}
			</NewspaperText>
			<NewspaperText
				x={props.displayDetails.details.title.x}
				y={props.displayDetails.details.title.y}
				projection={{
					width: props.displayDetails.details.title.w,
					height: props.displayDetails.details.title.h
				}}
				fontSize={props.displayDetails.details.title.fontSize}
				data-testid={`${testBase}-top-description`}
			>
				{props.displayDetails.details.title.text}:
			</NewspaperText>

			<PreviewDetails
				entry={props.entry}
				testBase={testBase}
				displayDetails={props.displayDetails}
			/>

			<NewspaperText
				x={props.displayDetails.bottomDescription.title.x}
				y={props.displayDetails.bottomDescription.title.y}
				projection={{
					width: props.displayDetails.bottomDescription.title.w,
					height: props.displayDetails.bottomDescription.title.h
				}}
				fontSize={21}
				data-testid={`${testBase}-bottom-description-title`}
			>
				{props.displayDetails.bottomDescription.title.text}:
			</NewspaperText>
			<NewspaperText
				x={props.displayDetails.bottomDescription.text.x}
				y={props.displayDetails.bottomDescription.text.y}
				projection={{
					width: props.displayDetails.bottomDescription.text.w,
					height: props.displayDetails.bottomDescription.text.h
				}}
				fontSize={props.displayDetails.bottomDescription.text.fontSize}
				data-testid={`${testBase}-bottom-description-body`}
			>
				{props.entry.bottomDescription}
			</NewspaperText>
			<Asset.Img
				key={props.entry.id}
				x={props.entry.previewImage.x}
				y={props.entry.previewImage.y}
				scale={props.entry.previewImage.scale ?? 1}
				projection={props.entry.previewImage.img}
				data-testid={`${testBase}-image`}
			/>
		</>
	);
}

function PreviewDetails(props) {
	const testBase = `${props.testBase}-details`;
	return props.displayDetails.details.labels.map(
		(label, index) => (
			<React.Fragment
				key={label.text}
			>
				<NewspaperText

					x={label.x}
					y={label.y}
					fontSize={props.displayDetails.details.labelsFontSize}
					data-testid={`${testBase}-${label.text}-label`}
				>
					{label.text}:
				</NewspaperText>
				<NewspaperText
					key={`${label.text}_value`}
					x={props.displayDetails.details.valueX}
					y={label.y}
					fontSize={props.displayDetails.details.labelsFontSize}
					data-testid={`${testBase}-${label.text}-value`}
				>
					{props.entry.detailsValues[index]}
				</NewspaperText>
			</React.Fragment>
		)
	);
}

const NewspaperText = styled(Asset.Text)`
	font-family: "KG Corner of the Sky";
	text-align: left;
	line-height: 1.6em;
	color: #1f261f;
`;

export default NewspaperPreview;
